import { signIn } from "next-auth/react";
import { FaGoogle } from "react-icons/fa";

type GoogleAuthButtonProps = {
    text: string
}

const GoogleAuthButton = (props: GoogleAuthButtonProps) => {

    const { text } = props;
    const handleGoogleSignUp = async () => {
        await signIn("google", {
            callbackUrl: "/",
            redirect: false,
        });
    };

    return (
        <div className="flex flex-col justify-center items-center mt-4 space-y-3 pb-5 px-6">
            <button
                type="button"
                onClick={handleGoogleSignUp}
                className="flex items-center justify-center border border-gray-300 rounded-lg px-4 py-2 w-full hover:bg-gray-100"
            >
                <FaGoogle size={20} color="#DB4437" className="mr-3" />
                <span className="text-gray-700">{text}</span>
            </button>
        </div>
    );
}

export default GoogleAuthButton;